import * as logger from 'loglevel';
import axios from 'axios';
import dayjs from 'dayjs';
import { getUuid } from '@front10/helpers/dist/uuid';

const transformData = (data) =>
  data.homes_listings.listings.map(({ location, listing, pricing }) => {
    const hostCategory = listing.is_superhost ? 'Superhost' : '';
    return {
      placeDescription: listing.name,
      originCity: listing.room_type,
      popularity: listing.star_rating,
      destinationCity: location.city,
      formattedTotalPrice: pricing.total && pricing.total.amount_formatted,
      formattedPriceRate: pricing.rate && pricing.rate.amount_formatted,
      rateType: pricing.rate_type,
      currencyCode: pricing.rate && pricing.rate.currency,
      destinationImage: listing.picture_url,
      index: getUuid(),
      id: listing.id,
      hostCategory,
      farenetTravelClass: hostCategory,
      travelClass: hostCategory,
      bedrooms: listing.bedrooms,
      bathrooms: listing.bathrooms,
      beds: listing.beds,
      reviewsQty: listing.reviews_count,
      guests: listing.person_capacity,
    };
  });

/**
 * Makes sure the listing response is complain with a basic schema
 * @param {*} listing
 */
const validateListingResponse = (data) => {
  const validation = { isValid: true, message: '' };
  if (
    !data ||
    !data.homes_listings ||
    !data.homes_listings.listings ||
    !Array.isArray(data.homes_listings.listings)
  ) {
    validation.isValid = false;
    return {
      isValid: false,
      data,
      message: 'INTEGRATION__AIRBNB__LISTINGS: listings must be an Array',
    };
  }
  const { listings } = data.homes_listings;
  if (listings.length > 0) {
    const listing = listings[0];
    if (!listing.listing || !listing.location || !listing.pricing) {
      return {
        isValid: false,
        data: listing,
        message:
          'INTEGRATION__AIRBNB__LISTINGS: Listing SCHEMA is invalid, please check Listing API documentation.',
      };
    }
  }
  return validation;
};

/**
 * Propmise for get filtered featured listings
 */
const getOffers = (
  {
    origin,
    budget,
    dateRange,
    homeType,
    languageCode = 'EN',
    currency = 'USD',
    itemCount = 10,
    ...filter
  },
  integrationSettings
) =>
  new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__AIRBNB__LISTINGS: **integrationSettings** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v2AirbnbListings: listingApiSettings } = integrationSettings;

    if (!listingApiSettings || !listingApiSettings.method || !listingApiSettings.endPoint) {
      const MESSAGE = `INTEGRATION__AIRBNB__LISTINGS: **integrationSettings.listingApiSettings** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    const params = {
      client_id: listingApiSettings.token,
      location: origin,
      price_max: budget,
      checkin: dateRange.start ? dayjs(dateRange.start).format('YYYY-MM-DD') : null,
      checkout: dateRange.end ? dayjs(dateRange.end).format('YYYY-MM-DD') : null,
      room_types: homeType && Array.isArray(homeType) ? homeType.join(',') : null,
      locale: languageCode,
      currency,
      items_per_grid: itemCount,
      ...filter,
    };

    Object.keys(params).map((key) => !params[key] && delete params[key]);

    axios({
      method: listingApiSettings.method,
      url: listingApiSettings.endPoint,
      params,
    })
      .then((response) => {
        const validation = validateListingResponse(response.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__AIRBNB__LISTINGS: Successful request', response.data);
          const listings = transformData(response.data);
          resolve(listings);
        } else {
          logger.error(validation.message, validation.data);
          reject(response.data);
        }
      })
      .catch((err) => {
        const error = `INTEGRATION__AIRBNB__LISTINGS: ${err}`;
        logger.error('INTEGRATION__AIRBNB__LISTINGS:', err);
        reject(error);
      });
  });

export { getOffers, transformData };
